import {generalRequest} from '../services'
import {useQuery} from "@tanstack/react-query";

export async function getAwards(params) {
    return generalRequest.get('student/awards', params)
}

export async function getAwardsGamification(args= {}) {
    const cleanArgs = Object.fromEntries(
        Object.entries(args).filter(
            ([_, value]) => value !== undefined && value !== null
        )
    );

    const query = new URLSearchParams(cleanArgs).toString();

    return generalRequest.get(
        query
            ? `student/awards/gamification?${query}`
            : 'student/awards/gamification'
    );
}
export async function postTakeAward(args) {
    return generalRequest.post('student/awards/take', args)
}
export async function getTakeAward(args) {
    const cleanArgs = Object.fromEntries(
        Object.entries(args).filter(
            ([_, value]) => value !== undefined && value !== null
        )
    );

    const query = new URLSearchParams(cleanArgs).toString();

    return generalRequest.get(
        query
            ? `student/awards/take?${query}`
            : 'student/awards/take'
    );
}
export async function getAwardsRace(args) {
    const query = new URLSearchParams(args).toString();
    return generalRequest.get('student/awards/race?'+ query)
}
export async function getAwardDetail(id) {
    return generalRequest.get('student/award/' + id)
}
export async function getTopList(params){
    return generalRequest.get('student/awards/rank',params)
}